import { requestSubscription, graphql } from "react-relay";
import { ConnectionHandler } from "relay-runtime";
import environment from "../Network";

const subscription = graphql`
  subscription MeetingSubscription {
    meetingSubscription {
      action
      users
      meeting {
        createdAt
        updatedAt
        body
        name
        receivers {
          edges {
            node {
              lastName
              firstName
              id
              pk
            }
          }
        }
        createdBy {
          lastName
          firstName
          id
        }
        meetingDate
        pk
        id
        deleted
        public
      }
    }
  }
`;

export default (variables) => {
  return requestSubscription(
    environment, // see Environment docs
    {
      subscription,
      variables: variables ? variables : {},
      updater: (store) => {
        // Get the notification
        const rootField = store.getRootField("meetingSubscription");
        const meeting = rootField.getLinkedRecord("meeting");
        const action = rootField.getValue("action");
        const users = rootField.getValue("users");
        const is_public = meeting.getValue("public");
        let viewer = store.getRoot().getLinkedRecord("user");
        let pk = viewer.getValue("pk");
        const oldMeeting = store.get(meeting.getValue("id"));
        if (is_public || users.indexOf(pk) !== -1) {
          // post meetings
          let connection = ConnectionHandler.getConnection(
            viewer,
            "MeetingsList_meetings"
          );
          if (action === "delete") {
            ConnectionHandler.deleteNode(connection, meeting.getValue("id"));
          } else if (action === "create") {
            // test
            let meetingEdge = ConnectionHandler.createEdge(
              store,
              connection,
              meeting,
              "MeetingType"
            );
            ConnectionHandler.insertEdgeBefore(connection, meetingEdge);
          } else {
            if (oldMeeting) {
              oldMeeting.setValue(meeting.getValue("body"), "body");
              oldMeeting.setValue(meeting.getValue("name"), "name");
              oldMeeting.setValue(
                meeting.getValue("meetingDate"),
                "meetingDate"
              );
              oldMeeting.setValue(meeting.getValue("public"), "public");
              oldMeeting.setLinkedRecord(
                meeting.getLinkedRecord("receivers"),
                "receivers"
              );
            }
          }
        } else if (
          oldMeeting &&
          users.indexOf(pk) === -1 &&
          action === "update"
        ) {
          let connection = ConnectionHandler.getConnection(
            viewer,
            "MeetingsList_meetings"
          );
          ConnectionHandler.deleteNode(connection, meeting.getValue("id"));
        }
        viewer = store.getRoot().getLinkedRecord("adminMeetings");
        if (viewer) {
          let connection_list = ConnectionHandler.getConnection(
            viewer,
            "ManagementMeetingsTable_meetings"
          );
          let connection_calendar = ConnectionHandler.getConnection(
            viewer,
            "ManagementMeetingsCalendar_calendarMeetings"
          );
          if (action === "remove") {
            ConnectionHandler.deleteNode(
              connection_list,
              meeting.getValue("id")
            );
            ConnectionHandler.deleteNode(
              connection_calendar,
              meeting.getValue("id")
            );
          } else if (action === "create") {
            let meetingEdge = ConnectionHandler.createEdge(
              store,
              connection_list,
              meeting,
              "MeetingType"
            );
            ConnectionHandler.insertEdgeBefore(connection_list, meetingEdge);
            meetingEdge = ConnectionHandler.createEdge(
              store,
              connection_calendar,
              meeting,
              "MeetingType"
            );
            ConnectionHandler.insertEdgeBefore(
              connection_calendar,
              meetingEdge
            );
          }
        }
      },
      // optional but recommended:
      onCompleted: () => {
        /* server closed the subscription */
      },
      onError: (error) => console.error(error),
    }
  );
};



// WEBPACK FOOTER //
// ./src/subscriptions/MeetingSubscription.js